import React from "react";
import { useIntl } from "react-intl";
import { getTournamentName, getTournamentUrl } from "../utils";

export function TournamentName({ detail }) {
  const intl = useIntl();
  const name = getTournamentName(detail, intl);
  const url = getTournamentUrl(detail);
  if (url) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "underline" }}>
        {name}
      </a>
    );
  } else {
    return <>{name}</>;
  }
}
